












































































































































































































































import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { DiscountCode, ApiResponse, DiscountCodeResponse } from '@/models/DiscountCode';
import SingleSelect from '@/components/SingleSelect.vue';
import { websiteText } from '@/mixins/websiteTexts';
import { TextValuePair } from '@/models/TextValuePair';

declare var grecaptcha: any;
type RetailerDropDown = {
    name: string;
    city: string;
    organizationId: string;
};
@Component({
    components: {
        SingleSelect
    }
})
export default class DiscountCodeForm extends Vue {
    [x: string]: any;
    isLoaded: boolean = false;
    isLoading: boolean = false;
    isValid: boolean = true;
    title: string = '';
    text: string = '';
    systemId: string = '';
    discountCodeType = '';
    retailer: string = '';
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    address: string = '';
    postalCode: string = '';
    city: string = '';
    country: string = '';
    phoneNumber: string = '';
    employeeNumber: string = '';
    discountText: string = '';
    expirationDays: number = 365;
    company: string = '';
    discountCreationCode: string = '';
    concentPolicy: boolean = false;
    concentPolicyMissing: boolean = false;
    showDiscountCreationCode: boolean = false;
    redeemUrl: string = '';
    retailers: RetailerDropDown[] | null = null;

    discountResponse: DiscountCodeResponse = {
        qrUrl: '',
        code: '',
        url: ''
    };

    errorMsgs: string[] = [];
    gdprTitle: string;
    gdprText: '';
    recaptchaString: string;
    errors: { [key: string]: boolean } = {
        retailer: false,
        firstName: false,
        lastName: false,
        phoneNumber: false,
        email: false,
        address: false,
        zipCode: false,
        city: false,
        country: false,
        discountText: false,
        expirationDays: false,
        employeeNumber: false,
        company: false,
        discountCreationCode: false
    };

    constructor() {
        super();
        this.title = this.$attrs['data-title'];
        this.text = this.$attrs['data-text'];
        this.gdprTitle = this.$attrs['data-gdpr-title'];
        this.gdprText = JSON.parse(this.$attrs['data-gdpr-text']);
        this.recaptchaString = this.$attrs['data-recaptcha-site-key'];
        this.discountCodeType = this.$attrs['data-discount-code-type'];
        this.systemId = this.$attrs['data-systemid'];
        this.redeemUrl = this.$attrs['data-redeem-url'];
        this.discountText = this.$attrs['data-discount-text'];
        this.showDiscountCreationCode = this.$attrs['data-show-discount-cc'].toLowerCase() == 'true' ? true : false;
        this.retailers = JSON.parse(this.$attrs['data-retailers']) as RetailerDropDown[];
        this.$attrs['data-title'] = '';
        this.$attrs['data-text'] = '';
        this.$attrs['data-gdpr-text'] = '';
        this.$attrs['data-gdpr-title'] = '';
        this.$attrs['data-recaptcha-site-key'] = '';
        this.$attrs['data-discount-code-type'] = '';
        this.$attrs['data-systemid'] = '';
        this.$attrs['data-redeem-url'] = '';
        this.$attrs['data-discount-text'] = '';
        this.$attrs['data-retailers'] = '';
    }

    get retailerOptions(): TextValuePair[] {
        if (!this.retailers) return [];
        const retailers = this.retailers.map((retailer: RetailerDropDown) => {
            return {
                text: retailer.city + ' - ' + retailer.name,
                value: retailer.name
            };
        });
        return retailers || [];
    }

    selectRetailer(value: string[]) {
        this.retailer = value[0];
    }

    clearError(fieldName: string) {
        this.errors[fieldName] = false;
    }

    printDiscountCode() {
        window.print();
    }

    submitForm() {
        this.errorMsgs = [];
        const recaptchaSiteKey = this.recaptchaString; //(window as any).__litium.recaptchaSiteKey as string;

        if (!this.validateForm() || this.isLoading) {
            return;
        } else {
            this.isLoading = true;
            const submit = this.submit;
            grecaptcha.ready(function() {
                grecaptcha
                    .execute(recaptchaSiteKey, {
                        action: 'submit'
                    })
                    .then(function(token: string) {
                        submit(token);
                    });
            });
        }
    }

    submit(token: string) {
        if (this.concentPolicy || !this.showDiscountCreationCode) {
            const request: DiscountCode = {
                token: token,
                systemId: this.systemId,
                discountCreationCode: this.discountCreationCode,
                firstName: this.firstName,
                lastName: this.lastName,
                address: this.address,
                postalCode: this.postalCode,
                city: this.city,
                country: this.country,
                phoneNumber: this.phoneNumber,
                email: this.email,
                employeeNumber: this.employeeNumber,
                discountText: this.discountText,
                expirationDays: this.expirationDays,
                company: this.company,
                issuedBy: '',
                retailer: this.retailer,
                concentPolicy: true
            };

            const requestContext = (window as any).__litium.requestContext;
            axios({
                method: 'post',
                url: `/api/discountcode`,
                data: request,
                headers: {
                    'litium-request-context': JSON.stringify(requestContext)
                }
            })
                .then((response: any) => {
                    // const data = response.json();

                    const apiResponse: ApiResponse = response.data;
                    this.isLoading = false;
                    if (apiResponse.success) {
                        this.discountResponse = apiResponse.message;
                        const self = this;
                        setTimeout(function() {
                            self.isLoaded = true;
                        }, 600);
                    } else {
                        console.log('apiResponse', apiResponse);
                        if (this.showDiscountCreationCode && apiResponse.error == 'discountCreationCode') {
                            this.errorMsgs.push(websiteText('site.contactform.unknowndiscountcreationcode'));
                            this.errors['discountCreationCode'] = true;
                        }
                    }
                })
                .catch((e: any) => {
                    // handle error
                    console.error(e);
                });
        } else if (!this.concentPolicy && this.showDiscountCreationCode) {
            this.isLoading = false;
            this.concentPolicyMissing = true;
        } else {
            this.isLoading = false;
        }
    }

    //animate
    enter(element: HTMLElement) {
        const width = getComputedStyle(element).width;

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const height = getComputedStyle(element).height;

        element.style.width = '';
        element.style.position = '';
        element.style.visibility = '';
        element.style.height = '0';
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = height;
        });
    }
    afterEnter(element: HTMLElement) {
        element.style.height = 'auto';
    }
    leave(element: HTMLElement) {
        const height = getComputedStyle(element).height;

        element.style.height = height;
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = '0';
        });
    }
    //end animate

    validateForm(): boolean {
        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

        var returnValue = true;

        if (this.retailer == '' && this.discountCodeType == 'retailercustomer') {
            this.errorMsgs.push(websiteText('site.contactform.missingretailer'));
            this.errors['retailer'] = true;
            returnValue = false;
        }
        if (this.firstName == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingfirstname'));
            this.errors['firstName'] = true;
            returnValue = false;
        }
        if (this.lastName == '') {
            this.errorMsgs.push(websiteText('site.contactform.missinglastname'));
            this.errors['lastName'] = true;
            returnValue = false;
        }
        if (this.address == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingaddress'));
            this.errors['address'] = true;
            returnValue = false;
        }
        if (this.postalCode == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingzipcode'));
            this.errors['postalCode'] = true;
            returnValue = false;
        }
        if (this.country == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingcountry'));
            this.errors['country'] = true;
            returnValue = false;
        }
        if (this.city == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingcity'));
            this.errors['city'] = true;
            returnValue = false;
        }
        if (this.phoneNumber == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingphone'));
            this.errors['phoneNumber'] = true;
            returnValue = false;
        }
        if (this.email == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingemail'));
            this.errors['email'] = true;
            returnValue = false;
        } else if (!reg.test(this.email)) {
            this.errorMsgs.push(websiteText('site.contactform.emailincorrect'));
            this.errors['email'] = true;
            returnValue = false;
        }
        if (this.discountText == '' && this.discountCodeType == 'vip') {
            this.errorMsgs.push(websiteText('site.contactform.missingdiscounttext'));
            this.errors['discountText'] = true;
            returnValue = false;
        }
        if ((isNaN(this.expirationDays) || this.expirationDays < 0) && this.discountCodeType == 'vip') {
            this.errorMsgs.push(websiteText('site.contactform.incorrectexpirationdays'));
            this.errors['expirationDays'] = true;
            returnValue = false;
        }
        if (this.employeeNumber == '' && this.discountCodeType == 'vip') {
            this.errorMsgs.push(websiteText('site.contactform.missingemployeenumber'));
            this.errors['employeeNumber'] = true;
            returnValue = false;
        }
        if (this.company == '' && this.discountCodeType == 'stena') {
            this.errorMsgs.push(websiteText('site.contactform.missingcompany'));
            this.errors['company'] = true;
            returnValue = false;
        }
        if (this.discountCreationCode == '' && this.showDiscountCreationCode) {
            this.errorMsgs.push(websiteText('site.contactform.missingdiscountcreationcode'));
            this.errors['discountCreationCode'] = true;
            returnValue = false;
        }

        return returnValue;
    }
}
